export const disableAutofillBg = {
  '& input:-webkit-autofill': {
    transition: 'background-color 5000s ease-in-out 50000s',
  },
};
